/**
 * Root route for /tools/* (enduser interface).
 * Renders the ToolsLayout wrapper with Outlet for child routes.
 */
import { createRoute, Outlet, Navigate } from '@tanstack/react-router';
import { rootRoute } from '../__root';
import { ToolsLayout } from '@/components/tools/ToolsLayout';
import { useAuth, hasFeature } from '@/contexts/AuthContext';
import { AmadeusWebSocketProvider } from '@/contexts/AmadeusWebSocketContext';

function ToolsRootComponent() {
  const { user, isAuthenticated } = useAuth();

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has any features (or is staff/superuser)
  const userFeatures = user?.features || [];
  const hasAnyFeature = user?.is_staff || user?.is_superuser || userFeatures.length > 0;

  if (!hasAnyFeature) {
    return (
      <ToolsLayout>
        <div className="text-center py-16">
          <p className="text-slate-500">Keine Werkzeuge verfügbar.</p>
          <p className="text-sm text-slate-400 mt-2">
            Bitte wenden Sie sich an den Administrator.
          </p>
        </div>
      </ToolsLayout>
    );
  }

  return (
    <AmadeusWebSocketProvider>
      <ToolsLayout>
        <Outlet />
      </ToolsLayout>
    </AmadeusWebSocketProvider>
  );
}

export const toolsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/tools',
  component: ToolsRootComponent,
});
